import styled from '@emotion/styled';
import { Button, ButtonProps } from '@mui/material';

export const SubmitButton = styled(Button)<ButtonProps>(() => ({
  width: '100%',
  fontSize: '.9rem',
  '&, &:hover, &.Mui-disabled': {
    color: '#000',
    background: 'none',
    border: 0,
  },
}));